// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"232":"87190ec6","477":"e536af82"}[chunkId] + ".chunk.css");